export const EMPTY_VALUE = Symbol('EMPTY_VALUE');
